export default __webpack_public_path__ + "static/media/T-box-main.dfb077de.jpg";